import { render, staticRenderFns } from "./audio.vue?vue&type=template&id=23d3e992&scoped=true&"
import script from "./audio.vue?vue&type=script&lang=js&"
export * from "./audio.vue?vue&type=script&lang=js&"
import style0 from "./audio.vue?vue&type=style&index=0&id=23d3e992&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d3e992",
  null
  
)

export default component.exports